module.exports = __webpack_public_path__ + "img/10.60c12677.svg";